import { ISurveyOption, SurveyOption } from 'src/services/api/api-client';

export const createCommonOption = (args: Omit<ISurveyOption, 'discriminator' | 'questionScheme'>): SurveyOption => {
  const commonOption = new SurveyOption();
  commonOption.init({ ...args });
  return commonOption;
};
